import React, {useState} from 'react';
import {DrawerTriger} from "./FieldUser";
import {SwitchBasic} from "../../switch/SwitchBasic";
import InputSingle from "../../input/InputSingle";
import {deleteFiled, updateFiled} from "../../../api/field/FieldService";
import {handleActiveToast} from "../../sonner/ToastBasic";
import draggable from "../../../resources/icon/draggable.png";
import FieldFormatDisplay from "./FieldFormatDisplay";

/**
 * `필드 `데이트 `날짜
 * */

function FieldDate({each, setFlag, dragHandleProps}) {
    const [modify, setModify] =useState(false);
    const [data, setData] =useState(each);
    const update =()=>{
        setModify(true)
    }


    async function save(){
        const response = await updateFiled(data);
        if (response.status===200) {
            setModify(false)
            setFlag(true);
            handleActiveToast({description:"",message:"수정되었습니다.", labelListener:()=>{}})
        }else if(response.response.status===401){
            handleActiveToast({description:"",message:"로그인 하세요.", labelListener:()=>{}})
        }else if(response.response.status===403){
            handleActiveToast({description:"",message:"권한이 없습니다.", labelListener:()=>{}})
        }
    }

    async function deleteItem(){
        if(window.confirm("삭제 하시겠습니까")) {
            const response = await deleteFiled(data.id);
            if (response.status === 200) {
                setModify(false)
                setFlag(true);
                handleActiveToast({
                    description: "", message: "수정되었습니다.", labelListener: () => {
                    }
                })
            } else if (response.response.status === 401) {
                handleActiveToast({
                    description: "", message: "로그인 하세요.", labelListener: () => {
                    }
                })
            } else if (response.response.status === 403) {
                handleActiveToast({
                    description: "", message: "권한이 없습니다.", labelListener: () => {
                    }
                })
            }
        }
    }

    return (
        <>
            <th className="fieldset-th relative">
                {modify ? (
                    <InputSingle target={'title'}  data={{ data: data, setData: setData }} required={true} className={'field-add'}/>
                ):(<span className={"input-label"}>{each.title}</span>)}

                <img
                    src={draggable}
                    className="draggable-icon"
                    {...dragHandleProps}
                />
            </th>
            <td colSpan={3} className="fieldset-td">
                {modify ? (
                    <DrawerTriger className={data.isRequired ? "border-red" : ""}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                             stroke="currentColor" className="w-4 h-4 inline mt-[-2px] mr-[5px]">
                            <path strokeLinecap="round" strokeLinejoin="round"
                                  d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"/>
                        </svg>
                        날짜 선택
                    </DrawerTriger>
                ) : (
                    <FieldFormatDisplay type="DATE" />
                )}

                    <div className="inline-block relative">
                        {modify ? (
                            <SwitchBasic
                                onCheckedChange={(checked) => {
                                    setData((prev) => ({
                                        ...prev,
                                        isRequired: checked,
                                    }));
                                }}
                                className={"absolute top-[-15px] left-[258px]"} defaultChecked={each.isRequired}/>
                        ):(<></>)}
                    </div>


                {modify ? (
                    <>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] bg-cancel-important" onClick={()=>setModify(false)}>취소</button>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] bg-save-important" onClick={save}>저장 </button>
                    </>

                ) : (
                    <>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] bg-delete-important" onClick={deleteItem}>삭제</button>
                        <button className="list-btn float-right hover-black ml-auto mt-[2px] " onClick={update}>수정</button>
                    </>
                )}
            </td>
        </>
    );
}

export default FieldDate;